// extracted by mini-css-extract-plugin
module.exports = {"category-card":"CategoryCard_category-card__3ZaqE"};